import axios from '@/axios'

const state = {
  division: null
}

const getters = {
  division: state => state.division
}

const mutations = {
  SET_DIVISION: (state, division) => {
    state.division = division
  }
}

const actions = {
  getDivision({commit}, {event, entrytype, category, gender, unfiltered}) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/event-workouts/get-division-workouts/${event}`, {
          entrytype: entrytype,
          category: category,
          gender: gender,
          unfiltered: unfiltered
        })
        .then(response => {
          commit('SET_DIVISION', response.data)
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.data)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
